import React from 'react'
import PropTypes from 'prop-types'
import './styles/index.css'


const Subject = ({ subject }) => {
  if (!subject || subject === '') return null

  return (
    <p className="subject-tag">
      {subject}
    </p>
  )
}

Subject.propTypes = {
  subject: PropTypes.string.isRequired
}

export default Subject



// WEBPACK FOOTER //
// ./src/node_modules/components/Pimper/MobileCarousel/Subject.js